import { Subscription } from "@rails/actioncable";
import { cableStore } from "@/store/typed";

export class GenericAdapter {
  onResponse: (data: any) => void;
  constructor(onResponse: (data: any) => void) {
    this.onResponse = onResponse;
  }

  received(data) {
    if (this.onResponse) {
      this.onResponse(data);
    }
  }
}

export default class GenericCable {
  subscription: (Subscription & GenericAdapter) | null = null;

  onResponse: (data: any) => void;

  close() {
    cableStore.disconnect();
  }

  async open(cableName: string) {
    const params = {
      channel: cableName,
    };
    const handler = new GenericAdapter(this.onResponse);

    this.subscription = await cableStore.subscribe({
      params,
      handler,
    });
  }
}
